module.exports = __webpack_public_path__ + "static/media/shuklaNVPH2.9ac5fab2.webp";